import { AloftArea, AloftPrice, schAloftArea, schAloftPrice } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectOpinionOfSiteValue } from './opinionOfSiteValueSelectors.ts';
import { selectSiteEntities } from './propertyDataSelectors/siteSelectors.ts';

const selectOpinionOfSiteValuePerSF = createSelector(
  [selectOpinionOfSiteValue, selectSiteEntities],
  (opinionOfSiteValue, sites) => {
    const siteValue = schAloftPrice.safeParse(opinionOfSiteValue);
    const { subject } = sites;

    if (!subject || !siteValue.success) return AloftPrice.zero;

    const siteArea = schAloftArea.safeParse(subject.area);
    if (!siteArea.success || siteArea.data.equals(AloftArea.zero)) return AloftPrice.zero;

    return siteValue.data.div(siteArea.data.getUnitAmount('sqft'));
  },
);

export const selectOpinionOfSiteValuePerSFDisplay = createSelector(
  [selectOpinionOfSiteValuePerSF],
  (perSF) => perSF.toString(false, true),
);
